import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceDetailsRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-details',
	path: '/jira/customer-service-management/projects/:projectKey/settings/details',
	exact: true,
};
